module.exports = __webpack_public_path__ + "img/economy-CO2.aea667e0.svg";